import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import Tabs from 'srcReact/components/common2/Tabs'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import { useTranslation } from 'react-i18next'
import MembersTabContent from 'srcReact/components/common2/MembersTabContent'

const Members = ({ groupId, selectedScope }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [pagination, setPagination] = useState({ nextOffset: 0, isPagination: false })
  const [members, setMembers] = useState([])
  const [scope, setScope] = useState('active_members')
  const [activeTab, setActiveTab] = useState(0)

  const {
    login: { user: loggedInUser },
    workplace: { current_workplace },
    groupHome: { group, membersLoading, searchedMemberError, users, usersStat, userAfterChangedRole, userRemoved }
  } = useSelector((state) => state)

  useEffect(() => {
    setMembers([...users])
  }, [scope, users])

  useEffect(() => {
    if (selectedScope === 'staff') {
      setScope('staff')
      setActiveTab(1)
    }
  }, [selectedScope])

  const isLoggedInUserOrganizer = () => {
    if (group && group.logged_user) {
      return group.logged_user.group_role === 'organizer'
    }
    return false
  }

  const handleAddCoorganizer = (userId) => {
    if (group) {
      dispatch(groupHomeActions.addStaffRole(group.id, userId, 'co-organizer'))
    }
  }
  const handleRemoveCoorganizer = (userId) => {
    if (group) {
      dispatch(groupHomeActions.removeStaffRole(group.id, userId, scope))
    }
  }
  const handleRemoveFromGroup = (userId) => {
    if (group) {
      dispatch(groupHomeActions.removeFromGroup(group.id, userId))
    }
  }
  const lastMemberRef = useInfinitScroll(
    membersLoading,
    usersStat && usersStat.remaining,
    usersStat && usersStat.next_offset,
    setPagination,
    [membersLoading]
  )

  const getMembers = (searchValue, order) => {
    dispatch(groupHomeActions.getParticipants(groupId, scope, pagination, searchValue, order))
  }

  const showParticipants = () => {
    setScope('active_members')
  }

  const showOrganizers = () => {
    setScope('staff_members')
  }

  return (
    <div className={styles.membersWrapper}>
      <Tabs type='boxed' initialActive={activeTab} hasCountInLabel={true}>
        <div
          onClick={showParticipants}
          label={`${t('global.members')} ${
            group && group.members && group.members.active > 0 ? '(' + group.members.active + ')' : ''
          }`}>
          <MembersTabContent
            type='group'
            members={members}
            scope={scope}
            isOrganizer={isLoggedInUserOrganizer()}
            groupRole={group && group.logged_user.group_role}
            pagination={pagination}
            setPagination={setPagination}
            membersLoading={membersLoading}
            searchedMemberError={searchedMemberError}
            lastMemberRef={lastMemberRef}
            current_workplace={current_workplace}
            getMembers={getMembers}
            loggedInUser={loggedInUser}
            handleAddCoorganizer={handleAddCoorganizer}
            handleRemoveCoorganizer={handleRemoveCoorganizer}
            handleRemoveFromGroup={handleRemoveFromGroup}
            userAfterRoleChanged={userAfterChangedRole}
            userRemoved={userRemoved}
          />
        </div>
        <div
          onClick={showOrganizers}
          label={`${t('groupHome.members.leadership')} ${
            group && group.members && group.members.staff > 0 ? '(' + group.members.staff + ')' : ''
          }`}>
          <MembersTabContent
            type='group'
            members={members}
            scope={scope}
            isOrganizer={isLoggedInUserOrganizer()}
            groupRole={group && group.logged_user.group_role}
            pagination={pagination}
            setPagination={setPagination}
            membersLoading={membersLoading}
            searchedMemberError={searchedMemberError}
            lastMemberRef={lastMemberRef}
            current_workplace={current_workplace}
            getMembers={getMembers}
            loggedInUser={loggedInUser}
            handleAddCoorganizer={handleAddCoorganizer}
            handleRemoveCoorganizer={handleRemoveCoorganizer}
            handleRemoveFromGroup={handleRemoveFromGroup}
            userAfterRoleChanged={userAfterChangedRole}
            userRemoved={userRemoved}
          />
        </div>
      </Tabs>
    </div>
  )
}

export default Members
